import React from 'react';
import styled from 'styled-components';
import { Button, Space } from '@gr-monorepo/common/ui';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { ReactComponent as IconLetters } from './icon_letters.svg';

const DownloadPlate = styled.div`
  display: flex;
  align-items: center;
  background: rgba(244, 245, 246, 1);
  border-radius: 10px;
  padding: 24px 24px;
  gap: 24px;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
`;
const LettersIcon = styled.div`
  display: flex;
`;

const DownloadGratitudeLetters = () => {
  const { logPageEvent } = useClickStreamContext();
  const handleClickButton = () => {
    window.location.href = 'https://vk.cc/cvkAwO';
    logPageEvent({
      eventType: 'olymp_click_download_gratitude_letters',
      eventInfo: 'Клик по кнопке Скачать благодарственные письма',
    });
  };

  return (
    <>
      <DownloadPlate>
        <LettersIcon>
          <IconLetters />
        </LettersIcon>
        <span>
          Отметьте достижения школ в олимпиадах с помощью благодарственных писем. Они доступны в разделе «
          <a href="https://vk.cc/cvkAwO" style={{ color: 'rgba(18, 183, 231, 1)' }}>
            Портфолио
          </a>
          ».
        </span>
        <Button onClick={handleClickButton} style={{ width: 160, flex: '0 0 auto' }}>
          СКАЧАТЬ
        </Button>
      </DownloadPlate>
      <Space axis="vertical" size={40} />
    </>
  );
};

export default DownloadGratitudeLetters;
